import { IsFilledType } from "@website/utils/is-filled/is-filled.types";
import toString from "lodash-es/toString";
import trim from "lodash-es/trim";

export const isFilled = ((value) =>
  !["", "Invalid Date", "NaN"].includes(trim(toString(value)))) as IsFilledType;
